var map = {
	"./index.js": 3
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1;



/*****************
 ** WEBPACK FOOTER
 ** ./resolving/context/~/subcontent ./resolving/context/loaders/queryloader.js?query!^\.\/.*\.js$
 ** module id = 1
 ** module chunks = 0
 **/